module.exports = __webpack_public_path__ + "static/media/Eelektrik_gaussian2.686a47de.png";